import { store } from '../store';
import { GetRegion } from '../constants';

export const isOnApaKeyForUserSuspended = () => {
  const region = GetRegion();
  const isApaKeyUserSuspended = store.getState().metadata
    ?.suspended_refresh_hours_time;
  const apaKeyUserSuspended = !isApaKeyUserSuspended
    ? {}
    : JSON.parse(isApaKeyUserSuspended || '{}');

  const isOnfunctionalityUserSuspended =
    apaKeyUserSuspended[region]?.enable !== undefined ? apaKeyUserSuspended[region]?.enable : apaKeyUserSuspended?.default?.enable;

  const castIfOnFuncionalityUserSuspendedIsString =
    typeof isOnfunctionalityUserSuspended === 'string'
      ? isOnfunctionalityUserSuspended.toLowerCase() === 'true'
      : isOnfunctionalityUserSuspended;

  return isApaKeyUserSuspended
    ? castIfOnFuncionalityUserSuspendedIsString
    : false;
};
